import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { i18n } from '@/plugin/vue-i18n';
import { CheckDone01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIModal, UIModalContent, UIModalFooter, UIModalHeader, } from '@gohighlevel/ghl-ui';
import { CHAT_WIDGET_IDS, EMIT_EVENTS } from '../../helper/const';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfirmationModal',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'primary',
        },
        title: {
            type: String,
            default: '',
        },
        description: {
            type: String,
            default: '',
        },
        icon: {
            type: Function,
        },
        id: {
            type: String,
            default: CHAT_WIDGET_IDS.MODAL_DEFAULT,
        },
        submitText: {
            type: String,
            default: i18n.global.t('common.submit'),
        },
        cancelText: {
            type: String,
            default: i18n.global.t('common.cancel'),
        },
        loading: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        chatWidgetName: {
            type: String,
            default: '',
        },
    },
    emits: [EMIT_EVENTS.SUBMIT, EMIT_EVENTS.CLOSE],
    setup(__props, { emit }) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), { show: __props.show }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: __props.id,
                        type: __props.type,
                        title: __props.title,
                        description: __props.description,
                        chatWidgetName: __props.chatWidgetName,
                        icon: _unref(CheckDone01Icon),
                        onClose: _cache[0] || (_cache[0] = ($event) => (emit(_unref(EMIT_EVENTS).CLOSE)))
                    }, null, 8 /* PROPS */, ["id", "type", "title", "description", "chatWidgetName", "icon"])
                ]),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: __props.submitText,
                        negativeText: __props.cancelText,
                        onPositiveClick: _cache[1] || (_cache[1] = ($event) => (emit(_unref(EMIT_EVENTS).SUBMIT))),
                        onNegativeClick: _cache[2] || (_cache[2] = ($event) => (emit(_unref(EMIT_EVENTS).CLOSE))),
                        loading: __props.loading,
                        disabled: __props.disabled,
                        id: _unref(CHAT_WIDGET_IDS).MODAL_FOOTER_DEFAULT,
                        type: __props.type
                    }, null, 8 /* PROPS */, ["positiveText", "negativeText", "loading", "disabled", "id", "type"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), null, {
                        default: _withCtx(() => [
                            _renderSlot(_ctx.$slots, "default")
                        ]),
                        _: 3 /* FORWARDED */
                    })
                ]),
                _: 3 /* FORWARDED */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
